import { NavLink, Outlet } from 'react-router-dom';
import { cx } from '@mobi/web';

const TABS = [
  {
    to: '/',
    label: 'Rodar',
    icon: (
      <path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm0 2.2a7.8 7.8 0 0 1 7.6 6.1h-4.2A3.8 3.8 0 0 0 12 8.3a3.8 3.8 0 0 0-3.4 2H4.4A7.8 7.8 0 0 1 12 4.2ZM4.3 12.5h4.4a3.8 3.8 0 0 0 2.2 2.4v4.7a7.8 7.8 0 0 1-6.6-7.1Zm8.8 7.1v-4.7a3.8 3.8 0 0 0 2.2-2.4h4.4a7.8 7.8 0 0 1-6.6 7.1ZM12 10.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z" />
    ),
  },
  {
    to: '/ganhos',
    label: 'Ganhos',
    icon: (
      <path d="M4 20V10h4v10H4Zm6 0V4h4v16h-4Zm6 0v-6h4v6h-4Z" />
    ),
  },
  {
    to: '/perfil',
    label: 'Perfil',
    icon: (
      <path d="M12 2a5 5 0 1 1 0 10 5 5 0 0 1 0-10Zm0 12c5 0 9 2.5 9 6v2H3v-2c0-3.5 4-6 9-6Z" />
    ),
  },
];

export function Shell() {
  return (
    <div className="h-app flex flex-col bg-surface">
      <main className="min-h-0 flex-1">
        <Outlet />
      </main>

      <nav className="border-t border-line bg-surface pb-[max(0.5rem,env(safe-area-inset-bottom))]">
        <ul className="mx-auto flex max-w-md">
          {TABS.map((tab) => (
            <li key={tab.to} className="flex-1">
              <NavLink
                to={tab.to}
                end={tab.to === '/'}
                className={({ isActive }) =>
                  cx(
                    'flex min-h-14 flex-col items-center justify-center gap-1 pt-2 text-xs font-medium transition',
                    isActive ? 'text-brand' : 'text-faint',
                  )
                }
              >
                {({ isActive }) => (
                  <>
                    <svg
                      viewBox="0 0 24 24"
                      className={cx('h-6 w-6', isActive ? 'fill-brand' : 'fill-faint')}
                      aria-hidden="true"
                    >
                      {tab.icon}
                    </svg>
                    {tab.label}
                  </>
                )}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
}
